export default __webpack_public_path__ + "static/media/andrelago.fa74b3c8.jpg";